const maintenanceEn = {
    maintenance: require('../../lang/en/maintenance/Maintenance').default,
    corrective: require('../../lang/en/maintenance/CorrectiveMaintenance').default,
    preventive: require('../../lang/en/maintenance/PreventiveMaintenance').default,
}

export default maintenanceEn;

